module.exports = __webpack_public_path__ + "52b4efc61f35abb3c28e0cf304029bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/cushion@2x.png
// module id = 307
// module chunks = 0